import swal from 'sweetalert2'

export default {
  data () { return {btReturnPending: false, btReturnTimer: null, btReturnChecks: 0, btReturnKey: null} },
  watch: {
    order: {
      immediate: true,
      handler (order) {
        if (!order || order.payment_id !== 'btIpay' || !order.id) {
          clearTimeout(this.btReturnTimer)
          this.btReturnTimer = null
          this.btReturnPending = false
          this.btReturnKey = null
          return
        }
        const key = 'bt-return:' + order.company_id + ':' + order.id
        if (key !== this.btReturnKey) {
          clearTimeout(this.btReturnTimer)
          this.btReturnTimer = null
          this.btReturnChecks = 0
          this.btReturnKey = key
        }
        const returned = Number(order.is_refunded) === 1 || ['refund OK', 'reversal OK'].indexOf(order.capture_transaction_status) >= 0
        if (returned) this.$session.remove(key)
        this.btReturnPending = !returned && this.$session.get(key) === true
        if (!this.btReturnPending) {
          clearTimeout(this.btReturnTimer)
          this.btReturnTimer = null
        }
        if (this.btReturnPending && !this.btReturnTimer && this.btReturnChecks < 30) {
          this.btReturnTimer = setTimeout(() => {
            this.btReturnTimer = null
            this.btReturnChecks++
            this.getData()
          }, 10000)
        }
      }
    }
  },
  beforeDestroy () { clearTimeout(this.btReturnTimer) },
  methods: {
    btStatusBlocked (status) {
      return this.order && this.order.payment_id === 'btIpay' && this.order.status &&
        this.order.status.id === 'DRAFT_AWAITING_PAYMENT' && ['CANCELED', 'NOT_DELIVERED'].indexOf(status) < 0
    },
    handleBtReturnQueued () {
      if (!this.order || this.order.payment_id !== 'btIpay') return
      const key = 'bt-return:' + this.order.company_id + ':' + this.order.id
      this.$session.set(key, true)
      this.btReturnPending = true
      this.btReturnChecks = 0
      swal({text: this.$t('btPayments.returnPending'), type: 'info'}).catch(() => {})
      this.getData()
      this.$session.set('refreshOrdersCount', 'refresh')
      if (typeof this.callback === 'function') this.callback(this.order.id)
      if (this.$bus) this.$bus.$emit('refresh', this.order.id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/BtOrderPayment.js